module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleClose),
      expression: "handleClose"
    }],
    staticClass: "w-select"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentInput),
      expression: "currentInput"
    }],
    ref: "inner-input",
    staticClass: "w-select-inner-input input",
    attrs: {
      "type": "text",
      "placeholder": _vm.currentPlaceholder || _vm.placeholder
    },
    domProps: {
      "value": (_vm.currentInput)
    },
    on: {
      "focus": _vm.onfocus,
      "click": _vm.handleOpen,
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.upEvent($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.downEvent($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterEvent($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentInput = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.nativeValue) ? _c('div', {
    staticClass: "w-select-clear",
    on: {
      "click": _vm.handleClear
    }
  }, [_vm._v("x")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDropdown),
      expression: "showDropdown"
    }],
    staticClass: "w-select-dropdown"
  }, [_vm._l((_vm.suggestion), function(item, index) {
    return _c('div', {
      key: item.value,
      staticClass: "w-select-option",
      class: {
        isHover: _vm.hoverIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.onChange(item)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")])
  }), _vm._v(" "), (!_vm.suggestion.length) ? _c('div', {
    staticClass: "w-select__empty"
  }, [_vm._v("无匹配数据")]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17f14838"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/w-select.vue
// module id = 847
// module chunks = 1